import React from "react";
import {
  Page,
  Navbar,
  NavRight,
  NavTitle,
  Link,
  Block,
  BlockTitle,
  Toolbar,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  List,
  ListInput,
  ListItem,
  ListItemCell,
  Icon,
  Button,
  Row,
  Col,
  Popup,
  Preloader,
  TextEditor,
  Checkbox,
  Toggle,
} from "framework7-react";

import moment from "moment";
import { GoogleApiWrapper, Map, Marker } from "google-maps-react";
import { GOOGLE_MAP } from "../config/fbConfig";
import { getDistance, convertDistance } from "geolib";

// Redux
import { compose } from "redux";
import { connect } from "react-redux";
import { withFirestore, firestoreConnect } from "../HOCs";
import {
  toast,
  handleErrors,
  sendEasychawOneTimePassword,
  verifyEasychawOneTimePassword,
} from "../utils/_helpers";
import { Collections, FilterByText, FilterBySelect } from "../utils/_classes";

class AdminVendors extends React.Component {
  constructor() {
    super();

    this.state = {
      popupOpened: false,
      popupDataChanged: false,
      popupData: {
        title: "",
        which: "",
      },

      vendorSheetOpened: false,
      vendorSheetData: null,

      // for filtering of assignment of delivery agents to merchants
      deliveryAgentsAssignmentFilters: {
        name: "",
        email: "",
        deliveryMeans: "All",
      },

      // merchant commission
      commissionFreeSales: "",
      commissionOnSales: "",
      commissionOnDelivery: "",

      // merchant inclusive delivery
      deliveryInclusiveLimit: "",

      // sales single order detail
      salesOrderDetails: null,

      // notification data
      notificationTitle: "",
      notificationBody: "",

      // application data
      vendor: null,
      reason: "",

      // map
      geoLoc: null,

      // state for form fields reset
      vendorBusinessName: "",
      vendorEmail: "",
      vendorCategory: "All",
      vendorType: "All",
      vendorStatus: "All",

      // Data state
      vendors: [],

      filterBy: {
        dbName: "",
        property: "",
        value: "",
        type: "",
      },
    };
  }

  render() {
    return (
      <Page>
        <Block>
          <Card
            className="data-table data-table-init"
            style={{
              width: "100%",
              marginLeft: "0px",
              marginBottom: "80px",
              // maxHeight: '700px',
            }}
          >
            <CardHeader>
              <div className="data-table-title">All Vendors</div>
            </CardHeader>
            <CardContent
              padding={false}
              style={{
                width: "100%",
                maxHeight:
                  parseInt(window.innerWidth) <= 1400 ? "70vh" : "80vh",
                paddingBottom: "20px",
                overflow: "scroll",
              }}
            >
              <table className="sticky">
                <thead>
                  <tr>
                    <th>
                      <span className="table-head-label">SNo.</span>
                    </th>
                    <th className="input-cell">
                      <span className="table-head-label">Business name</span>
                      <div className="input">
                        <input
                          type="text"
                          value={this.state.vendorBusinessName}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              vendorBusinessName: e.target.value,
                              vendorEmail: "",
                              vendorCategory: "All",
                              vendorType: "All",
                              vendorStatus: "All",
                              filterBy: {
                                dbName: "vendors",
                                property: "name",
                                value: e.target.value,
                                type: "text",
                              },
                            })
                          }
                          placeholder="Filter"
                        />
                      </div>
                    </th>
                    <th className="input-cell">
                      <span className="table-head-label">Business Email</span>
                      <div className="input">
                        <input
                          type="email"
                          value={this.state.vendorEmail}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              vendorBusinessName: "",
                              vendorEmail: e.target.value,
                              vendorCategory: "All",
                              vendorType: "All",
                              vendorStatus: "All",
                              filterBy: {
                                dbName: "vendors",
                                property: "email",
                                value: e.target.value,
                                type: "text",
                              },
                            })
                          }
                          placeholder="Filter"
                        />
                      </div>
                    </th>
                    <th className="input-cell">
                      <span className="table-head-label">Category</span>
                      <div className="input input-dropdown">
                        <select
                          value={this.state.vendorCategory}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              vendorBusinessName: "",
                              vendorEmail: "",
                              vendorCategory: e.target.value,
                              vendorType: "All",
                              vendorStatus: "All",
                              filterBy: {
                                dbName: "vendors",
                                property: "category",
                                value: e.target.value,
                                type: "select",
                              },
                            })
                          }
                        >
                          <option value="All">All</option>
                          <option value="Food">Food</option>
                          <option value="Buses">Buses</option>
                          <option value="Trucks">Trucks</option>
                          <option value="Bikes">Bikes</option>
                          <option value="Multiple">Multiple</option>
                          <option value="Referral">Referral</option>
                        </select>
                      </div>
                    </th>
                    <th className="input-cell">
                      <span className="table-head-label">Type</span>
                      <div className="input input-dropdown">
                        <select
                          value={this.state.vendorType}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              vendorBusinessName: "",
                              vendorEmail: "",
                              vendorCategory: "All",
                              vendorType: e.target.value,
                              vendorStatus: "All",
                              filterBy: {
                                dbName: "vendors",
                                property: "type",
                                value: e.target.value,
                                type: "select",
                              },
                            })
                          }
                        >
                          <option value="All">All</option>
                          <option value="fleetNumber">Delivery</option>
                          <option value="ownsDelivery">Merchant</option>
                          <option value="partnerType">Referral Agent</option>
                        </select>
                      </div>
                    </th>
                    <th className="input-cell">
                      <span className="table-head-label">Status</span>
                      <div className="input input-dropdown">
                        <select
                          value={this.state.vendorStatus}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              vendorBusinessName: "",
                              vendorEmail: "",
                              vendorCategory: "All",
                              vendorType: "All",
                              vendorStatus: e.target.value,
                              filterBy: {
                                dbName: "vendors",
                                property: "accountStatus",
                                value: e.target.value,
                                type: "select",
                              },
                            })
                          }
                        >
                          <option value="All">All</option>
                          <option value="Approved">Approved</option>
                          <option value="Pending">Pending</option>
                          <option value="Suspended">Suspended</option>
                        </select>
                      </div>
                    </th>
                    <th>
                      <span className="table-head-label">Actions</span>
                    </th>
                    <th>
                      <span className="table-head-label">Profile</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.vendors
                    .sort(
                      (a, b) => parseInt(b.timestamp) - parseInt(a.timestamp),
                    )
                    .map((vendor, i) => (
                      <tr key={i}>
                        <td>{i + 1} </td>
                        <td>
                          <div>{vendor.businessProfile.name}</div>
                        </td>
                        <td>
                          <div>{vendor.businessProfile.email}</div>
                        </td>
                        <td>
                          {vendor.businessProfile.partnerType
                            ? vendor.businessProfile.partnerType
                            : vendor.businessProfile.category}
                        </td>
                        <td>
                          <div>
                            {vendor.businessProfile.partnerType
                              ? "Referral Agent"
                              : vendor.businessProfile.ownsDelivery
                              ? "Merchant"
                              : "Delivery"}
                          </div>
                        </td>
                        <td>{vendor.accountStatus}</td>
                        <td>
                          {vendor.accountStatus === "Pending" ? (
                            <Button
                              fill
                              onClick={() => {
                                this.setState({
                                  ...this.state,
                                  vendor,
                                  popupOpened: true,
                                  popupDataChanged: true,
                                  popupData: {
                                    title: "Vendor Application",
                                    which: "application",
                                  },
                                });
                                this.initMap(vendor.businessProfile.geoLoc);
                              }}
                            >
                              Approve
                            </Button>
                          ) : vendor.accountStatus === "Suspended" ? (
                            <Button
                              fill
                              className="button-fill-green"
                              onClick={(e) => {
                                let collection = vendor.businessProfile
                                  .partnerType
                                  ? "partners"
                                  : vendor.businessProfile.ownsDelivery
                                  ? "merchants"
                                  : "delivery";
                                this.actionAgainstVendor(
                                  "release",
                                  collection,
                                  vendor.id,
                                );
                              }}
                            >
                              Release
                            </Button>
                          ) : vendor.accountStatus !== "Declined" ? (
                            <Button
                              fill
                              className="button-fill-red"
                              onClick={(e) => {
                                let collection = vendor.businessProfile
                                  .partnerType
                                  ? "partners"
                                  : vendor.businessProfile.ownsDelivery
                                  ? "merchants"
                                  : "delivery";
                                this.actionAgainstVendor(
                                  "Suspend",
                                  collection,
                                  vendor.id,
                                );
                              }}
                            >
                              Suspend
                            </Button>
                          ) : null}
                        </td>
                        <td>
                          {vendor.accountStatus !== "Pending" && (
                            <Button
                              fill
                              onClick={() => {
                                this.setState({
                                  ...this.state,
                                  vendor,

                                  // vendorBusinessName: '',
                                  // vendorEmail: '',
                                  // vendorCategory: 'All',
                                  // vendorType: 'All',
                                  // vendorStatus: 'All',
                                  // filterBy: {
                                  //   dbName: 'vendors',
                                  //   property: 'type',
                                  //   value: 'All',
                                  //   type: 'select',
                                  // },

                                  popupOpened: true,
                                  popupDataChanged: true,
                                  popupData: {
                                    title: "Vendor Application",
                                    which: "application",
                                  },
                                });
                                this.initMap(vendor.businessProfile.geoLoc);
                              }}
                            >
                              View
                            </Button>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </CardContent>
          </Card>
        </Block>

        <Popup
          swipeToClose="to-bottom"
          className="easychaw-popup"
          opened={this.state.popupOpened}
          onPopupClosed={() =>
            this.setState({
              ...this.state,
              popupOpened: false,
              popupDataChanged: false,
              popupData: { title: "", which: "" },
              vendor: null,
              commissionFreeSales: "",
              commissionOnSales: "",
              commissionOnDelivery: "",
            })
          }
          onPopupOpened={(e) => e.app.methods.showFullText()}
        >
          <Page>
            <Navbar title={this.state.popupData.title}>
              <NavRight>
                <Link popupClose>Close</Link>
              </NavRight>
            </Navbar>

            <Block className="pattern-banner bg-color-jasmine">
              <Card style={{ width: "100%", margin: 0 }}>
                <CardHeader>
                  <h3 style={{ margin: 0 }}>
                    {this.state.vendor &&
                    this.state.vendor.businessProfile.partnerType
                      ? "Personal"
                      : "Business"}{" "}
                    Details
                  </h3>

                  <Button
                    style={{
                      fontFamily: "OpenSans",
                    }}
                    outline
                    iconF7="doc_on_clipboard"
                    onClick={(e) => this.$f7.methods.copyText(e, "Wallet Id")}
                  >
                    &nbsp;&nbsp;&nbsp;Wallet Id:
                    <span className="copytext">
                      {this.state.vendor && this.state.vendor.walletId}
                    </span>
                  </Button>
                </CardHeader>
              </Card>
            </Block>

            {/* Content for view vendor application */}
            {this.state.popupData.which == "application" ? (
              <Block>
                {/* [Card-0] Application note */}
                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader>
                    {this.state.vendor &&
                      this.state.vendor.businessProfile.name}
                  </CardHeader>
                  <CardContent className="no-padding">
                    <Row noGap>
                      <Col
                        width="60"
                        style={{
                          height: "180px",
                          position: "relative",
                          overflow: "hidden",
                          borderBottomLeftRadius: "5px",
                        }}
                      >
                        <Block
                          className="pab"
                          style={{ width: "100%", height: "100%" }}
                        >
                          <Row>
                            <Col width="100">
                              <h2 className="display-flex align-items-center no-margin">
                                <Icon
                                  f7="exclamationmark_triangle"
                                  style={{
                                    marginRight: "10px",
                                    fontSize: "24px",
                                  }}
                                ></Icon>
                                <span>Before Approving Account:</span>
                              </h2>
                            </Col>
                            <Col width="100">
                              <ul style={{ paddingInlineStart: "16px" }}>
                                <li>Check that user has a wallet id</li>
                                <li>Check that user has a valid map address</li>
                              </ul>
                            </Col>
                          </Row>
                        </Block>
                      </Col>

                      <Col
                        width="40"
                        style={{
                          backgroundImage: "url(static/icon-512x512@1x.png)",
                          backgroundSize: "cover",
                          height: "180px",
                          position: "relative",
                          overflow: "hidden",
                          borderBottomRightRadius: "5px",
                        }}
                      >
                        <img
                          className="item-image"
                          src={
                            this.state.vendor &&
                            this.state.vendor.businessProfile.images.logo.URL
                          }
                          alt="item logo"
                          style={{
                            position: "absolute",
                            top: "-10%",
                            left: "-10%",
                            width: "119%",
                            zIndex: 0,
                            height: "240px",
                            objectFit: "cover",
                            objectPosition: "center",
                            filter: "blur(4px)",
                            backgroundColor: "#fafafa",
                          }}
                        />
                        <img
                          className="item-image"
                          src={
                            this.state.vendor &&
                            this.state.vendor.businessProfile.images.logo.URL
                          }
                          alt="item logo"
                          style={{
                            opacity: 0.98,
                            height: "180px",
                            objectFit: "contain",
                            objectPosition: "center",
                          }}
                        />
                      </Col>
                    </Row>
                  </CardContent>
                </Card>
                {/* [Card-1] Application Details */}
                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader>
                    {this.state.vendor &&
                      this.props.data.users[this.state.vendor.id].fullName}
                  </CardHeader>
                  <CardContent>
                    <List noHairlinesMd>
                      <ListItem
                        className="show-text"
                        title="Profile uploaded on"
                      >
                        <small slot="after">
                          {this.state.vendor &&
                            ` ${moment(
                              Number(this.state.vendor.timestamp),
                            ).format("MMMM DD,YYYY | hh:mm")}`}
                        </small>
                        <Icon f7="briefcase" slot="media" />
                      </ListItem>

                      <ListItem className="show-text">
                        <p slot="title">
                          {this.state.vendor &&
                            this.state.vendor.businessProfile.name}
                        </p>
                        <Icon f7="briefcase" slot="media" />
                      </ListItem>
                      {this.state.vendor &&
                        !this.state.vendor.businessProfile.partnerType && (
                          <ListItem className="show-text">
                            <p slot="title">
                              {this.state.vendor &&
                                this.state.vendor.businessProfile.slogan}
                            </p>
                            <Icon f7="pencil_outline" slot="media" />
                          </ListItem>
                        )}

                      <ListItem className="show-text">
                        <p slot="title">
                          {this.state.vendor &&
                            this.state.vendor.businessProfile.address}
                        </p>
                        <Icon f7="map_pin_ellipse" slot="media" />
                      </ListItem>
                      <ListItem>
                        <p slot="title">
                          {this.state.vendor &&
                            this.state.vendor.businessProfile.phone}
                        </p>
                        <Icon f7="phone" slot="media" />
                      </ListItem>
                      <ListItem className="show-text">
                        <p slot="title">
                          {this.state.vendor &&
                            this.state.vendor.businessProfile.email}
                        </p>
                        <Icon f7="envelope" slot="media" />
                      </ListItem>
                      <ListItem>
                        <p slot="title">
                          {this.state.vendor &&
                            this.state.vendor.businessProfile.country}
                        </p>
                        <Icon f7="globe" slot="media" />
                      </ListItem>
                    </List>
                    <h5>
                      Vendor Category: &nbsp;
                      <span>
                        {this.state.vendor
                          ? this.state.vendor.businessProfile.partnerType
                            ? "Referral"
                            : this.state.vendor.businessProfile.ownsDelivery
                            ? "Merchant"
                            : "Delivery"
                          : null}
                      </span>
                    </h5>
                    {this.state.vendor &&
                    this.state.vendor.businessProfile.partnerType ? (
                      <List noHairlinesMd>
                        <ListItem>
                          <p slot="title">
                            {this.state.vendor &&
                              this.state.vendor.businessProfile.partnerType}
                          </p>
                          <Icon f7="layers_alt" slot="media" />
                        </ListItem>

                        <ListItem title="Employed">
                          <p slot="after">
                            {this.state.vendor &&
                              this.state.vendor.businessProfile.employed}
                          </p>
                          <Icon f7="briefcase" slot="media" />
                        </ListItem>

                        <ListItem title="Languages">
                          <p slot="after">
                            {this.state.vendor &&
                              Object.keys(
                                this.state.vendor.businessProfile
                                  .spokenLanguages,
                              ).map((language, i) => {
                                if (language === "others") {
                                  return (
                                    <span key={i}>
                                      {
                                        this.state.vendor.businessProfile
                                          .spokenLanguages[language]
                                      }
                                      ,{" "}
                                    </span>
                                  );
                                } else {
                                  if (
                                    this.state.vendor.businessProfile
                                      .spokenLanguages[language]
                                  ) {
                                    return <span key={i}>{language}, </span>;
                                  }
                                }
                              })}
                          </p>
                          <Icon f7="car_fill" slot="media" />
                        </ListItem>
                      </List>
                    ) : this.state.vendor.businessProfile.ownsDelivery ? (
                      <List noHairlinesMd>
                        <ListItem>
                          <p slot="title">
                            {this.state.vendor &&
                              this.state.vendor.businessProfile.category}
                          </p>
                          <Icon f7="layers_alt" slot="media" />
                        </ListItem>

                        <ListItem>
                          <p slot="title">
                            {this.state.vendor &&
                              this.state.vendor.businessProfile.ownsDelivery}
                          </p>
                          <Icon f7="car_fill" slot="media" />
                        </ListItem>
                      </List>
                    ) : (
                      <List noHairlinesMd>
                        <ListItem>
                          <p slot="title">
                            {this.state.vendor &&
                              this.state.vendor.businessProfile.category}
                          </p>
                          <Icon f7="layers_alt" slot="media" />
                        </ListItem>
                        <ListItem title="Fleet Number">
                          <p slot="after">
                            {this.state.vendor &&
                              this.state.vendor.businessProfile.fleetNumber}
                          </p>
                          <Icon f7="car_fill" slot="media" />
                        </ListItem>
                      </List>
                    )}
                  </CardContent>
                </Card>
                {/* [Card-2] Application Documents  */}
                <Card
                  style={{
                    margin: "auto",
                    marginTop: "10pt",
                  }}
                >
                  <CardHeader>
                    {" "}
                    {this.state.vendor &&
                    this.state.vendor.businessProfile.partnerType
                      ? "Personal"
                      : "Business"}{" "}
                    Documents
                  </CardHeader>
                  <CardContent>
                    <Row>
                      {this.state.vendor &&
                        !this.state.vendor.businessProfile.partnerType && (
                          <Col>
                            <Card className="application-documents">
                              <CardHeader
                                className="no-border"
                                valign="bottom"
                              ></CardHeader>
                              <CardContent>
                                <Link
                                  external
                                  target="_blank"
                                  href={
                                    this.state.vendor &&
                                    this.state.vendor.businessProfile.images
                                      .certificate1.URL
                                  }
                                >
                                  Business Registration Certificate
                                </Link>
                              </CardContent>
                            </Card>
                          </Col>
                        )}

                      <Col>
                        <Card className="application-documents">
                          <CardHeader className="no-border" valign="bottom">
                            <Link external href=".static/1.jpg" />
                          </CardHeader>
                          <CardContent>
                            <Link
                              external
                              target="_blank"
                              href={
                                this.state.vendor &&
                                this.state.vendor.businessProfile.images
                                  .certificate2.URL
                              }
                            >
                              Voter id/Drivers license/National id
                            </Link>
                          </CardContent>
                        </Card>
                      </Col>
                    </Row>
                  </CardContent>
                </Card>
                {/* [Card-3] Application Map */}
                <Card
                  className="application-map"
                  style={{
                    margin: "auto",
                    marginTop: "10pt",
                  }}
                >
                  <CardHeader>Geo-location</CardHeader>
                  <CardContent>
                    <div
                      id="aMap"
                      className="business-map"
                      style={{
                        height: "300px",
                        width: "100%",
                        position: "relative",
                      }}
                    >
                      <Map
                        google={this.props.google}
                        zoom={18}
                        initialCenter={{
                          lat: 4.824167,
                          lng: 7.033611,
                        }}
                        center={
                          !this.state.geoLoc
                            ? {
                                lat: 4.824167,
                                lng: 7.033611,
                              }
                            : this.state.geoLoc
                        }
                      >
                        <Marker
                          name={"Location"}
                          position={
                            !this.state.geoLoc
                              ? {
                                  lat: 4.824167,
                                  lng: 7.033611,
                                }
                              : this.state.geoLoc
                          }
                          // name={"Current location"}
                        />
                      </Map>
                    </div>
                  </CardContent>
                </Card>
                {/* [Card-4] Referral Agent */}
                {this.state.vendor &&
                this.state.vendor.businessProfile.partnerType ? (
                  this.state.vendor.walletId ? (
                    <Card
                      className="data-table data-table-init"
                      style={{
                        margin: "auto",
                        marginTop: "10pt",
                      }}
                    >
                      <CardHeader>
                        <div className="data-table-title">Assigned Vendors</div>
                        <div className="data-table-actions">
                          <Button
                            outline
                            iconF7="doc_on_clipboard"
                            onClick={(e) =>
                              this.$f7.methods.copyText(e, "Referral Code")
                            }
                          >
                            &nbsp;&nbsp;&nbsp;Referral Code:{" "}
                            <span className="copytext">
                              {this.state.vendor.businessProfile.referralId}
                            </span>
                          </Button>
                        </div>
                      </CardHeader>

                      {this.state.vendor &&
                      [
                        ...this.props.ordered.merchants,
                        ...this.props.ordered.delivery,
                      ].filter(
                        (v) =>
                          v.referralAgentId ===
                          this.state.vendor.businessProfile.referralId,
                      ).length > 0 ? (
                        <CardContent
                          padding={false}
                          style={{
                            width: "100%",
                            // height: 'calc(60vh - 50px)',
                            paddingBottom: "20px",
                            maxHeight: "80vh",
                          }}
                        >
                          <table className="sticky">
                            <thead>
                              <tr>
                                <th>Unassign</th>
                                <th>Vendor Name</th>
                                <th>Vendor Email</th>
                                <th>Vendor Type</th>
                              </tr>
                            </thead>
                            <tbody>
                              {[
                                ...this.props.ordered.merchants,
                                ...this.props.ordered.delivery,
                              ]
                                .filter(
                                  (v) =>
                                    v.referralAgentId ===
                                    this.state.vendor.businessProfile
                                      .referralId,
                                )
                                .map((vendor, i) => (
                                  <tr key={i}>
                                    <td className="checkbox-cell">
                                      <Checkbox
                                        checked={true}
                                        onChange={(e) =>
                                          this.makeOrRemoveReferral(
                                            e,
                                            vendor.id,
                                            vendor.businessProfile.ownsDelivery
                                              ? "merchants"
                                              : "delivery",
                                            vendor.businessProfile.name,
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <div>{vendor.businessProfile.name}</div>
                                    </td>
                                    <td>
                                      <div>{vendor.businessProfile.email}</div>
                                    </td>
                                    <td>
                                      <div>
                                        {vendor.businessProfile.ownsDelivery
                                          ? "Merchant"
                                          : "Delivery"}
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </CardContent>
                      ) : (
                        <CardContent padding={false}>
                          <Block className="block-info">
                            <Row>
                              <Col>
                                <p>No assigned vendors!</p>
                              </Col>
                            </Row>
                          </Block>
                        </CardContent>
                      )}

                      <CardFooter className="easyPrintText">
                        <pre>
                          <small>
                            Referred vendors:{" "}
                            {
                              [
                                ...this.props.ordered.merchants,
                                ...this.props.ordered.delivery,
                              ].filter(
                                (v) =>
                                  v.referralAgentId ===
                                  this.state.vendor.businessProfile.referralId,
                              ).length
                            }
                          </small>
                        </pre>

                        <Button
                          fill
                          onClick={() => {
                            this.setState({
                              ...this.state,
                              vendorSheetOpened: true,
                              vendorSheetData: this.state.vendor,
                              vendorBusinessName: "",
                              vendorEmail: "",
                              vendorCategory: "All",
                              vendorType: "All",
                              vendorStatus: "All",
                              filterBy: {
                                dbName: "vendors",
                                property: "type",
                                value: "All",
                                type: "select",
                              },
                            });
                          }}
                        >
                          Assign Vendors
                        </Button>
                      </CardFooter>
                    </Card>
                  ) : (
                    <Card
                      style={{
                        margin: "auto",
                        marginTop: "10pt",
                      }}
                    >
                      <CardHeader>
                        <div className="data-table-title">Assigned Vendors</div>
                      </CardHeader>

                      <CardContent padding={false}>
                        <Block className="pab">
                          <Row>
                            <Col>
                              <p>This referral agent has no bank wallet!</p>
                            </Col>
                          </Row>
                        </Block>
                      </CardContent>
                    </Card>
                  )
                ) : null}
                {/* Card-5 Merchant verification card */}
                {this.state.vendor &&
                this.state.vendor.businessProfile.ownsDelivery ? (
                  <Card
                    style={{
                      margin: "auto",
                      marginTop: "10pt",
                    }}
                  >
                    <CardHeader>
                      <div>Verified by Easychaw</div>
                    </CardHeader>
                    <CardContent padding={false}>
                      <List simpleList>
                        <ListItem>
                          <ListItemCell className="width-auto flex-shrink-0">
                            <Icon f7="checkmark_seal_fill" color="blue" />
                          </ListItemCell>
                          <ListItemCell className="flex-shrink-3">
                            <p>Verified</p>
                          </ListItemCell>
                          <ListItemCell className="width-auto flex-shrink-4">
                            <Toggle
                              color="black"
                              onToggleChange={(e) =>
                                this.verifyMerchant(
                                  !this.props.data.merchants[
                                    this.state.vendor.id
                                  ]?.verified,
                                )
                              }
                              defaultChecked={
                                this.props.data.merchants[this.state.vendor.id]
                                  ?.verified
                              }
                            ></Toggle>
                          </ListItemCell>
                        </ListItem>
                      </List>
                    </CardContent>
                  </Card>
                ) : null}
                {/* Card-6 Delivery Branch access card */}
                {this.state.vendor &&
                !this.state.vendor.businessProfile.ownsDelivery &&
                !this.state.vendor.businessProfile.partnerType ? (
                  <Card
                    style={{
                      margin: "auto",
                      marginTop: "10pt",
                    }}
                  >
                    <CardHeader>
                      <div>Branches Creation Access</div>
                    </CardHeader>
                    <CardContent padding={false}>
                      <List simpleList>
                        <ListItem>
                          <ListItemCell className="width-auto flex-shrink-0">
                            <Icon f7="arrow_branch" color="blue" />
                          </ListItemCell>
                          <ListItemCell className="flex-shrink-3">
                            <p>Access</p>
                          </ListItemCell>
                          <ListItemCell className="width-auto flex-shrink-4">
                            <Toggle
                              color="black"
                              onToggleChange={(e) =>
                                this.grantOrRevokeBranchAccess(
                                  !this.props.data.delivery[
                                    this.state.vendor.id
                                  ]?.branchAccess,
                                )
                              }
                              defaultChecked={
                                this.props.data.delivery[this.state.vendor.id]
                                  ?.branchAccess
                              }
                            ></Toggle>
                          </ListItemCell>
                        </ListItem>
                      </List>
                    </CardContent>
                  </Card>
                ) : null}
                {/* Card-7 & Card-8 Merchant commision | Assign Delivery */}
                {this.state.vendor &&
                this.state.vendor.businessProfile.ownsDelivery ? (
                  <>
                    <Card
                      style={{
                        margin: "auto",
                        marginTop: "10pt",
                      }}
                    >
                      <CardHeader>
                        <div>Merchant Settings</div>
                      </CardHeader>

                      <CardContent padding={false}>
                        <List simpleList>
                          <ListItem>
                            <ListItemCell className="width-auto flex-shrink-0">
                              <Icon f7="gift"></Icon>
                            </ListItemCell>
                            <ListItemCell className="flex-shrink-3">
                              <p>Commission Free Sales</p>
                            </ListItemCell>
                            <ListItemCell className="width-auto flex-shrink-4">
                              <input
                                type="number"
                                style={{
                                  textAlign: "center",
                                }}
                                placeholder={
                                  this.props.data?.settings?.easychaw?.promo?.[
                                    this.state.vendor.id
                                  ]?.commissionFreeSales ??
                                  this.props.data?.settings?.easychaw
                                    ?.defaultCommissionFreeSales
                                }
                                value={this.state.commissionFreeSales}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    commissionFreeSales: e.target.value,
                                  })
                                }
                              />
                            </ListItemCell>
                            <ListItemCell className="width-auto flex-shrink-0">
                              <h6>
                                {this.props.data?.settings?.easychaw?.promo?.[
                                  this.state.vendor.id
                                ]?.commissionFreeSales ??
                                  this.props.data?.settings?.easychaw
                                    ?.defaultCommissionFreeSales}
                              </h6>
                            </ListItemCell>
                          </ListItem>

                          <ListItem>
                            <ListItemCell className="width-auto flex-shrink-0">
                              <Icon f7="percent"></Icon>
                            </ListItemCell>
                            <ListItemCell className="flex-shrink-3">
                              <p>Commission On Sales</p>
                            </ListItemCell>
                            <ListItemCell className="width-auto flex-shrink-4">
                              <input
                                type="number"
                                style={{
                                  textAlign: "center",
                                }}
                                placeholder={
                                  this.props.data?.settings?.easychaw?.promo?.[
                                    this.state.vendor.id
                                  ]?.commissionOnSales ?? 3.5
                                }
                                value={this.state.commissionOnSales}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    commissionOnSales: e.target.value,
                                  })
                                }
                              />
                            </ListItemCell>
                            <ListItemCell className="width-auto flex-shrink-0">
                              <h6>
                                {this.props.data?.settings?.easychaw?.promo?.[
                                  this.state.vendor.id
                                ]?.commissionOnSales ?? 3.5}
                              </h6>
                            </ListItemCell>
                          </ListItem>

                          <ListItem>
                            <ListItemCell className="width-auto flex-shrink-0">
                              <Icon f7="car_fill"></Icon>
                            </ListItemCell>
                            <ListItemCell className="flex-shrink-3">
                              <p>Inclusive Products Limit</p>
                            </ListItemCell>
                            <ListItemCell className="width-auto flex-shrink-4">
                              <input
                                type="number"
                                style={{
                                  textAlign: "center",
                                }}
                                placeholder={
                                  this.props.data?.settings?.easychaw?.promo?.[
                                    this.state.vendor.id
                                  ]?.deliveryInclusiveLimit ??
                                  this.props.data?.settings?.easychaw
                                    ?.deliveryInclusiveLimit ??
                                  0
                                }
                                value={this.state.deliveryInclusiveLimit}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    deliveryInclusiveLimit: e.target.value,
                                  })
                                }
                              />
                            </ListItemCell>
                            <ListItemCell className="width-auto flex-shrink-0">
                              <h6>
                                {this.props.data?.settings?.easychaw?.promo?.[
                                  this.state.vendor.id
                                ]?.deliveryInclusiveLimit ??
                                  this.props.data?.settings?.easychaw
                                    ?.deliveryInclusiveLimit ??
                                  0}
                              </h6>
                            </ListItemCell>
                          </ListItem>
                        </List>
                      </CardContent>

                      {
                        /* TODO: also check the role of the user if admin before showing footer to save commission */
                        this.props.data.merchants[this.state.vendor.id]
                          .accountStatus !== "Pending" ? (
                          <CardFooter>
                            <Button
                              fill
                              className="button-fill-blue"
                              style={{ width: "100%" }}
                              onClick={this.updateMerchantPromo.bind(this)}
                            >
                              Save Commission Changes
                            </Button>
                          </CardFooter>
                        ) : null
                      }
                    </Card>

                    <Card
                      className="data-table data-table-init"
                      style={{
                        margin: "auto",
                        marginTop: "10pt",
                      }}
                    >
                      <CardHeader>
                        <div className="data-table-title">
                          Assign Delivery Agents
                        </div>
                      </CardHeader>
                      <CardContent
                        padding={false}
                        style={{
                          width: "100%",
                          maxHeight: "80vh",
                          paddingBottom: "20px",
                          overflow: "scroll",
                        }}
                      >
                        <table className="sticky">
                          <thead>
                            <tr>
                              <th className="label-cell">Assign</th>
                              <th className="input-cell">
                                <span className="table-head-label">
                                  Delivery Name
                                </span>
                                <div className="input">
                                  <input
                                    type="text"
                                    placeholder="Filter"
                                    value={
                                      this.state.deliveryAgentsAssignmentFilters
                                        .name
                                    }
                                    onChange={(e) =>
                                      this.setState({
                                        ...this.state,
                                        deliveryAgentsAssignmentFilters: {
                                          ...this.state
                                            .deliveryAgentsAssignmentFilters,
                                          name: e.target.value,
                                        },
                                      })
                                    }
                                  />
                                </div>
                              </th>

                              <th className="input-cell">
                                <span className="table-head-label">
                                  Delivery Email
                                </span>
                                <div className="input">
                                  <input
                                    type="email"
                                    placeholder="Filter"
                                    value={
                                      this.state.deliveryAgentsAssignmentFilters
                                        .email
                                    }
                                    onChange={(e) =>
                                      this.setState({
                                        ...this.state,
                                        deliveryAgentsAssignmentFilters: {
                                          ...this.state
                                            .deliveryAgentsAssignmentFilters,
                                          email: e.target.value,
                                        },
                                      })
                                    }
                                  />
                                </div>
                              </th>

                              <th className="input-cell">
                                <span className="table-head-label">
                                  Delivey Means
                                </span>
                                <div className="input input-dropdown">
                                  <select
                                    value={
                                      this.state.deliveryAgentsAssignmentFilters
                                        .deliveryMeans
                                    }
                                    onChange={(e) =>
                                      this.setState({
                                        ...this.state,
                                        deliveryAgentsAssignmentFilters: {
                                          ...this.state
                                            .deliveryAgentsAssignmentFilters,
                                          deliveryMeans: e.target.value,
                                        },
                                      })
                                    }
                                  >
                                    <option value="All">All</option>
                                    <option value="1">Bike</option>
                                    <option value="2">Car</option>
                                  </select>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {/* TODO: Load all delivery companies in same city as merchant or just load all... 🤷🏾‍♂️ */}

                            {this.props.ordered.delivery
                              .filter(
                                ({ id, businessProfile: { name, email } }) =>
                                  id !== this.state.vendor.id &&
                                  name
                                    .toLowerCase()
                                    .includes(
                                      this.state.deliveryAgentsAssignmentFilters.name.toLowerCase(),
                                    ) &&
                                  email
                                    .toLowerCase()
                                    .includes(
                                      this.state.deliveryAgentsAssignmentFilters.email.toLowerCase(),
                                    ),
                              )
                              .filter(({ businessProfile: { category } }) => {
                                if (
                                  this.state.deliveryAgentsAssignmentFilters
                                    .deliveryMeans === "All"
                                ) {
                                  return true;
                                } else if (
                                  this.state.deliveryAgentsAssignmentFilters
                                    .deliveryMeans === "1"
                                ) {
                                  return category === "Bikes";
                                } else {
                                  return category !== "Bikes";
                                }
                              })
                              .sort(
                                (a, b) =>
                                  convertDistance(
                                    getDistance(
                                      this.state.vendor.businessProfile.geoLoc,
                                      a.businessProfile.geoLoc,
                                    ),
                                    "km",
                                  ) -
                                  convertDistance(
                                    getDistance(
                                      this.state.vendor.businessProfile.geoLoc,
                                      b.businessProfile.geoLoc,
                                    ),
                                    "km",
                                  ),
                              )
                              .map(
                                ({
                                  id,
                                  businessProfile: { name, email, category },
                                }) => (
                                  <tr key={id}>
                                    <td className="checkbox-cell">
                                      <Checkbox
                                        checked={
                                          this.props.data.merchants[
                                            this.state.vendor.id
                                          ].assignedDeliveryAgents
                                            ? this.props.data.merchants[
                                                this.state.vendor.id
                                              ].assignedDeliveryAgents.find(
                                                (v) => v === id,
                                              )
                                              ? true
                                              : false
                                            : false
                                        }
                                        onChange={(e) =>
                                          this.assignDeliveryAgentToMerchant(
                                            e.target.checked,
                                            id,
                                            name,
                                          )
                                        }
                                      />
                                    </td>

                                    <td>
                                      <div>{name}</div>
                                    </td>
                                    <td>
                                      <div>{email}</div>
                                    </td>
                                    <td>
                                      <div>{category}</div>
                                    </td>
                                  </tr>
                                ),
                              )}
                          </tbody>
                        </table>
                      </CardContent>
                    </Card>
                  </>
                ) : null}
                {/*  Delivery Agent commision | Assign Delivery */}
                {this.state.vendor &&
                !this.state.vendor.businessProfile.ownsDelivery &&
                !this.state.vendor.businessProfile.partnerType ? (
                  <Card
                    style={{
                      margin: "auto",
                      marginTop: "10pt",
                    }}
                  >
                    <CardHeader>
                      <div>Delivery Agent Settings</div>
                    </CardHeader>

                    <CardContent padding={false}>
                      <List simpleList>
                        <ListItem>
                          <ListItemCell className="width-auto flex-shrink-0">
                            <Icon f7="percent"></Icon>
                          </ListItemCell>
                          <ListItemCell className="flex-shrink-3">
                            <p>Commission On Delivery</p>
                          </ListItemCell>
                          <ListItemCell className="width-auto flex-shrink-4">
                            <input
                              type="number"
                              style={{
                                textAlign: "center",
                              }}
                              placeholder={
                                this.props.data?.settings?.easychaw?.promo?.[
                                  this.state.vendor.id
                                ]?.commissionOnDelivery ?? 3.5
                              }
                              value={this.state.commissionOnDelivery}
                              onChange={(e) =>
                                this.setState({
                                  ...this.state,
                                  commissionOnDelivery: e.target.value,
                                })
                              }
                            />
                          </ListItemCell>
                          <ListItemCell className="width-auto flex-shrink-0">
                            <h6>
                              {this.props.data?.settings?.easychaw?.promo?.[
                                this.state.vendor.id
                              ]?.commissionOnDelivery ?? 3.5}
                            </h6>
                          </ListItemCell>
                        </ListItem>
                      </List>
                    </CardContent>

                    {this.props.data.delivery[this.state.vendor.id]
                      .accountStatus !== "Pending" ? (
                      <CardFooter>
                        <Button
                          fill
                          className="button-fill-blue"
                          style={{ width: "100%" }}
                          onClick={this.updateMerchantPromo.bind(this)}
                        >
                          Save Commission Changes
                        </Button>
                      </CardFooter>
                    ) : null}
                  </Card>
                ) : null}
                {/* [Card-7 & Card-8] Admin Decision | Decline Reasons */}
                {this.state.vendor &&
                this.state.vendor.accountStatus === "Pending" ? (
                  <div>
                    <Card
                      style={{
                        margin: "auto",
                        marginTop: "10pt",
                      }}
                    >
                      <CardHeader>Admin Decision</CardHeader>
                      <CardFooter>
                        <Button
                          fill
                          style={{
                            backgroundImage:
                              "linear-gradient(#FF6969, #E02020)",
                            color: "white",
                            width: "40%",
                          }}
                          onClick={() => this.declineApplication()}
                        >
                          Decline
                        </Button>
                        <Button
                          fill
                          style={{
                            width: "40%",
                          }}
                          onClick={(e) => {
                            let collection = this.state.vendor.businessProfile
                              .partnerType
                              ? "partners"
                              : this.state.vendor.businessProfile.ownsDelivery
                              ? "merchants"
                              : "delivery";
                            this.actionAgainstVendor(
                              "Approve",
                              collection,
                              this.state.vendor.id,
                            );
                          }}
                        >
                          Approve
                        </Button>
                      </CardFooter>
                    </Card>

                    <Card
                      style={{
                        margin: "auto",
                        marginTop: "10pt",
                        display: "none",
                        animation: "glow 2s ease 0s 1",
                      }}
                      id="admin-decline-reasons"
                    >
                      <CardHeader className="no-border">
                        <span>Decline Reasons</span>
                        <Button
                          onClick={() => {
                            this.$f7.$("#admin-decline-reasons").hide();
                          }}
                        >
                          Close
                        </Button>
                      </CardHeader>
                      <CardContent>
                        <TextEditor
                          placeholder="Please state exact reasons for declining vendor application, you are encouraged to use bullet points to enable vendor to take the appropriate measures."
                          value={this.state.reason}
                          onTextEditorChange={(value) =>
                            this.setState({ ...this.state, reason: value })
                          }
                          buttons={[
                            ["bold", "italic", "underline", "strikeThrough"],
                            ["orderedList", "unorderedList"],
                          ]}
                        />
                      </CardContent>

                      <CardFooter>
                        <Button
                          round
                          fill
                          onClick={(e) => {
                            let collection = this.state.vendor.businessProfile
                              .partnerType
                              ? "partners"
                              : this.state.vendor.businessProfile.ownsDelivery
                              ? "merchants"
                              : "delivery";
                            this.decline(this.state.vendor.id, collection);
                          }}
                          style={{ width: "100%" }}
                        >
                          Post Message
                        </Button>
                      </CardFooter>
                    </Card>
                  </div>
                ) : null}
                {/* [Sheet Modal] Vendors Loader */}{" "}
                {this.state.vendorSheetOpened ? (
                  <div
                    style={{
                      margin: "auto",
                      width: "100%",
                      height: "50vh",
                      position: "fixed",
                      left: 0,
                      bottom: 0,
                      backgroundColor: "#f3f3f3",
                      zIndex: "15",
                    }}
                  >
                    {/* Modal Navbar */}
                    <div
                      className="display-flex justify-content-space-between align-items-center"
                      style={{
                        width: "100%",
                        height: "40px",
                        color: "rgba(22, 22, 22, 0.8)",
                        backgroundColor: "#fed448",
                      }}
                    >
                      <div style={{ fontSize: "12px", marginLeft: "16px" }}>
                        <b>
                          Assign Vendor to{" "}
                          {this.state.vendorSheetData.businessProfile.name}
                        </b>
                      </div>
                      <div
                        style={{ fontSize: "10px", marginRight: "16px" }}
                        onClick={() => {
                          this.setState({
                            ...this.state,
                            vendorSheetOpened: false,
                            vendorSheetData: null,
                            vendorBusinessName: "",
                            vendorEmail: "",
                            vendorCategory: "All",
                            vendorType: "All",
                            vendorStatus: "All",
                            filterBy: {
                              dbName: "vendors",
                              property: "type",
                              value: "All",
                              type: "select",
                            },
                          });
                        }}
                      >
                        Close
                      </div>
                    </div>

                    {/* Modal Content */}
                    <Card
                      className="data-table data-table-init"
                      style={{
                        marginLeft: "16px",
                        marginRight: "16px",
                      }}
                    >
                      <CardHeader>
                        <div className="data-table-title">Vendors</div>
                      </CardHeader>
                      <CardContent
                        padding={false}
                        style={{ width: "100%", height: "calc(40vh - 50px)" }}
                      >
                        <table className="sticky">
                          <thead>
                            <tr>
                              <th className="label-cell">Assign</th>
                              <th className="input-cell">
                                <span className="table-head-label">
                                  Vendor Name
                                </span>
                                <div className="input">
                                  <input
                                    type="text"
                                    value={this.state.vendorBusinessName}
                                    onChange={(e) =>
                                      this.setState({
                                        ...this.state,
                                        vendorBusinessName: e.target.value,
                                        vendorEmail: "",
                                        vendorCategory: "All",
                                        vendorType: "All",
                                        vendorStatus: "All",
                                        filterBy: {
                                          dbName: "vendors",
                                          property: "name",
                                          value: e.target.value,
                                          type: "text",
                                        },
                                      })
                                    }
                                    placeholder="Filter"
                                  />
                                </div>
                              </th>

                              <th className="input-cell">
                                <span className="table-head-label">
                                  Vendor Email
                                </span>
                                <div className="input">
                                  <input
                                    type="email"
                                    value={this.state.vendorEmail}
                                    onChange={(e) =>
                                      this.setState({
                                        ...this.state,
                                        vendorBusinessName: "",
                                        vendorEmail: e.target.value,
                                        vendorCategory: "All",
                                        vendorType: "All",
                                        vendorStatus: "All",
                                        filterBy: {
                                          dbName: "vendors",
                                          property: "email",
                                          value: e.target.value,
                                          type: "text",
                                        },
                                      })
                                    }
                                    placeholder="Filter"
                                  />
                                </div>
                              </th>

                              <th className="input-cell">
                                <span className="table-head-label">
                                  Vendor Type
                                </span>
                                <div className="input input-dropdown">
                                  <select
                                    value={this.state.vendorType}
                                    onChange={(e) =>
                                      this.setState({
                                        ...this.state,
                                        vendorBusinessName: "",
                                        vendorEmail: "",
                                        vendorCategory: "All",
                                        vendorType: e.target.value,
                                        vendorStatus: "All",
                                        filterBy: {
                                          dbName: "vendors",
                                          property: "type",
                                          value: e.target.value,
                                          type: "select",
                                        },
                                      })
                                    }
                                  >
                                    <option value="All">All</option>
                                    <option value="fleetNumber">
                                      Delivery
                                    </option>
                                    <option value="ownsDelivery">
                                      Merchant
                                    </option>
                                  </select>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.vendors
                              .filter((v) => {
                                if (
                                  v.accountStatus === "Declined" ||
                                  v.accountStatus === "Suspended" ||
                                  v.accountStatus === "Pending"
                                ) {
                                  return false;
                                } else {
                                  return true;
                                }
                              })
                              .filter((v) => !v.businessProfile.partnerType)
                              .filter((v) => {
                                if (
                                  [
                                    ...this.props.ordered.merchants,
                                    ...this.props.ordered.delivery,
                                  ].find(
                                    (pv) =>
                                      pv.id === v.id &&
                                      pv.businessProfile.name ===
                                        v.businessProfile.name &&
                                      ((pv.businessProfile.ownsDelivery &&
                                        v.businessProfile.ownsDelivery) ||
                                        (!pv.businessProfile.ownsDelivery &&
                                          !v.businessProfile.ownsDelivery)),
                                  ).referralAgentId
                                ) {
                                  return false;
                                } else {
                                  return true;
                                }
                              })
                              .map((vendor, i) => (
                                <tr key={i}>
                                  <td className="checkbox-cell">
                                    <Checkbox
                                      checked={false}
                                      onChange={(e) =>
                                        this.makeOrRemoveReferral(
                                          e,
                                          vendor.id,
                                          vendor.businessProfile.ownsDelivery
                                            ? "merchants"
                                            : "delivery",
                                          vendor.businessProfile.name,
                                        )
                                      }
                                    />
                                  </td>

                                  <td>
                                    <div>{vendor.businessProfile.name}</div>
                                  </td>
                                  <td>
                                    <div>{vendor.businessProfile.email}</div>
                                  </td>
                                  <td>
                                    <div>
                                      {vendor.businessProfile.ownsDelivery
                                        ? "Merchant"
                                        : "Delivery"}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </CardContent>
                    </Card>
                  </div>
                ) : null}
              </Block>
            ) : null}
          </Page>
        </Popup>
      </Page>
    );
  }

  //   Lifecycle

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.filterBy.dbName.trim() === "") {
      return {
        vendors:
          (nextProps.ordered &&
            nextProps.ordered.merchants &&
            nextProps.ordered.delivery &&
            nextProps.ordered.partners && [
              ...nextProps.ordered.merchants,
              ...nextProps.ordered.delivery,
              ...nextProps.ordered.partners,
            ]) ||
          [],
      };
    } else {
      let modifiedState = {
        vendors:
          (nextProps.ordered &&
            nextProps.ordered.merchants &&
            nextProps.ordered.delivery &&
            nextProps.ordered.partners && [
              ...nextProps.ordered.merchants,
              ...nextProps.ordered.delivery,
              ...nextProps.ordered.partners,
            ]) ||
          [],
      };

      switch (prevState.filterBy.dbName) {
        case "vendors":
          let filter;
          switch (prevState.filterBy.type) {
            case "text":
              filter = new FilterByText(modifiedState.vendors);
              return (modifiedState = {
                ...modifiedState,
                vendors: filter.filter(prevState),
              });

            default:
              filter = new FilterBySelect(modifiedState.vendors);
              return (modifiedState = {
                ...modifiedState,
                vendors: filter.filter(prevState),
              });
          }

        default:
        // inbox
      }
    }

    return null;
  }

  //   Events

  // Grant delivery permission to create branch
  grantOrRevokeBranchAccess(value) {
    this.$f7.preloader.show();
    // update merchant docs
    this.props.firestore
      .collection("delivery")
      .doc(this.state.vendor.id)
      .update({
        branchAccess: value,
      })
      .then(() => {
        this.$f7.preloader.hide();

        toast(this.$f7.toast, {
          text: `${this.state.vendor.businessProfile.name} ${
            value
              ? "now has permission to create "
              : "has been restricted from creating"
          } branches.`,
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }
  // Verify a merchant
  verifyMerchant(value) {
    this.$f7.preloader.show();
    // update merchant docs
    this.props.firestore
      .collection("merchants")
      .doc(this.state.vendor.id)
      .update({
        verified: value,
      })
      .then(() => {
        this.$f7.preloader.hide();

        toast(this.$f7.toast, {
          text: `${
            this.state.vendor.businessProfile.name
          } account verification ${
            value ? "successful" : "revoked"
          } on the Easychaw platform`,
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  // set commission for merchant
  updateMerchantPromo() {
    this.$f7.preloader.show();
    let update = {};

    if (this.state.commissionFreeSales !== "") {
      update.commissionFreeSales = parseInt(this.state.commissionFreeSales);
    }

    if (this.state.commissionOnSales !== "") {
      update.commissionOnSales = parseFloat(this.state.commissionOnSales);
    }

    if (this.state.commissionOnDelivery !== "") {
      update.commissionOnDelivery = parseFloat(this.state.commissionOnDelivery);
    }

    if (this.state.deliveryInclusiveLimit !== "") {
      update.deliveryInclusiveLimit = parseInt(
        this.state.deliveryInclusiveLimit,
      );
    }

    if (Object.keys(update).length === 0) {
      this.$f7.preloader.hide();
      this.setState({
        ...this.state,
        commissionFreeSales: "",
        commissionOnSales: "",
        commissionOnDelivery: "",
        deliveryInclusiveLimit: "",
      });

      return toast(this.$f7.toast, {
        text: `Settings updated`,
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    // TODO: send easychaw otp

    // send otp mail
    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        // send OTP to Easychaw's email
        sendEasychawOneTimePassword(
          { token: idToken, uid: this.props.auth.uid },
          (error, sent) => {
            if (error || !sent) {
              this.$f7.preloader.hide();
              return toast(this.$f7.toast, {
                text: error,
                position: "bottom",
                horizontalPosition: "center",
                closeButton: true,
                cssClass: "custom-toast",
                closeTimeout: 4000,
              });
            }

            // open a dialog to confirm OTP
            this.$f7.preloader.hide();
            this.$f7.dialog
              .create({
                title: "OTP CODE",
                cssClass: "otp-code-modal",
                text: "Confirm changes by filling in the OTP code sent to Easychaw's email address",
                content: `<input class="dialog-input split-input" type="password" maxlength="4" />`,
                buttons: [
                  // button to resend otp
                  {
                    text: "Resend Code",
                    color: "gray",
                    cssClass: "otp-resend",

                    close: false,
                    onClick: (dialog, e) => {
                      this.$f7.preloader.show();
                      sendEasychawOneTimePassword(
                        {
                          token: idToken,
                          uid: this.props.auth.uid,
                        },
                        (error, sent) => {
                          if (error || !sent) {
                            this.$f7.preloader.hide();
                            return toast(this.$f7.toast, {
                              text: error,
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                          }

                          this.$f7.preloader.hide();
                          return toast(this.$f7.toast, {
                            text: "OTP code sent",
                            position: "bottom",
                            horizontalPosition: "center",
                            closeButton: true,
                            cssClass: "custom-toast",
                            closeTimeout: 4000,
                          });
                        },
                      );
                    },
                  },
                  // button to cancel
                  {
                    text: "x",
                    color: "white",
                    cssClass: "otp-close",
                    onClick: (dialog, e) => {
                      this.$f7.preloader.hide();
                    },
                  },
                  // button to continue
                  {
                    text: "Continue",
                    bold: true,
                    cssClass: "otp-continue",
                    keyCodes: [13],
                    close: false,
                    onClick: (dialog, e) => {
                      this.$f7.preloader.show();
                      // password
                      const password = dialog.$el.find(".dialog-input").val();

                      // Verify otp
                      verifyEasychawOneTimePassword(
                        {
                          password,
                          token: idToken,
                          uid: this.props.auth.uid,
                        },
                        (error, success) => {
                          if (error || !success) {
                            this.$f7.preloader.hide();
                            return toast(this.$f7.toast, {
                              text: error,
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                          }

                          // close dialog
                          dialog.close();
                          const promo = {
                            ...this.props.data?.settings?.easychaw?.promo,
                            [this.state.vendor.id]: {
                              ...this.props.data?.settings?.easychaw?.promo?.[
                                this.state.vendor.id
                              ],
                              ...update,
                            },
                          };

                          this.props.firestore
                            .collection("settings")
                            .doc("easychaw")
                            .update({ promo })
                            .then(() => {
                              this.$f7.preloader.hide();
                              this.setState({
                                ...this.state,
                                commissionFreeSales: "",
                                commissionOnSales: "",
                                commissionOnDelivery: "",
                                deliveryInclusiveLimit: "",
                              });

                              return toast(this.$f7.toast, {
                                text: `Settings updated`,
                                position: "bottom",
                                horizontalPosition: "center",
                                closeButton: true,
                                cssClass: "custom-toast",
                                closeTimeout: 4000,
                              });
                            })
                            .catch((error) => {
                              this.$f7.preloader.hide();

                              toast(this.$f7.toast, {
                                text: handleErrors(error),
                                position: "bottom",
                                horizontalPosition: "center",
                                closeButton: true,
                                cssClass: "custom-toast",
                                closeTimeout: 4000,
                              });
                            });
                        },
                      );
                    },
                  },
                ],
              })
              .open();
          },
        );
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  // assign delivery agent to merchant
  assignDeliveryAgentToMerchant(assign, deliveryAgentId, deliveryAgentName) {
    this.$f7.preloader.show();

    // add or remove delivery agent
    let assignedDeliveryAgents = this.props.data.merchants[this.state.vendor.id]
      .assignedDeliveryAgents
      ? assign
        ? [
            ...this.props.data.merchants[this.state.vendor.id]
              .assignedDeliveryAgents,
            deliveryAgentId,
          ]
        : this.props.data.merchants[
            this.state.vendor.id
          ].assignedDeliveryAgents.filter((id) => id !== deliveryAgentId)
      : [deliveryAgentId];

    // update merchant docs
    this.props.firestore
      .collection("merchants")
      .doc(this.state.vendor.id)
      .update({ assignedDeliveryAgents })
      .then(() => {
        this.$f7.preloader.hide();

        toast(this.$f7.toast, {
          text: `Successfully ${
            assign ? "assigned" : "unassigned"
          } ${deliveryAgentName} to ${this.state.vendor.businessProfile.name}`,
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  // Make vendor referral of agent
  makeOrRemoveReferral(e, vendorId, which, vendorName) {
    this.$f7.preloader.show();
    if (e.target.checked) {
      // make referral
      this.props.firestore
        .collection(which)
        .doc(vendorId)
        .update({
          referralAgentId: this.state.vendor.businessProfile.referralId,
        })
        .then(() => {
          this.$f7.preloader.hide();

          toast(this.$f7.toast, {
            text: `Successfully made ${vendorName} a referral of Easychaw's Agent ${this.state.vendor.businessProfile.name}`,
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
        })
        .catch((error) => {
          this.$f7.preloader.hide();
          toast(this.$f7.toast, {
            text: handleErrors(error),
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
        });
    } else {
      // remove referral
      this.props.firestore
        .collection(which)
        .doc(vendorId)
        .update({
          referralAgentId: null,
        })
        .then(() => {
          this.$f7.preloader.hide();

          toast(this.$f7.toast, {
            text: `Successfully removed ${vendorName} as a referral of Easychaw's Agent ${this.state.vendor.businessProfile.name}`,
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
        })
        .catch((error) => {
          this.$f7.preloader.hide();
          toast(this.$f7.toast, {
            text: handleErrors(error),
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
        });
    }
  }

  decline(id, vendor) {
    this.$f7.preloader.show();

    this.props.firestore
      .collection(vendor)
      .doc(id)
      .update({
        accountStatus: "Declined",
        reason: {
          message: this.state.reason,
          timestamp: Date.now(),
        },
      })
      .then(() => {
        this.setState({
          ...this.state,
          reason: "",
          vendor: null,
          popupOpened: false,
          popupData: {
            title: "",
            which: "",
          },
        });
        this.$f7.preloader.hide();
        toast(this.$f7.toast, {
          text: "Declined",
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  actionAgainstVendor(type, vendor, id) {
    this.$f7.preloader.show();
    const action =
      type === "Approve"
        ? { accountStatus: "Approved", approved: true }
        : type === "Suspend"
        ? { accountStatus: "Suspended" }
        : { accountStatus: "Approved" };
    this.props.firestore
      .collection(vendor)
      .doc(id)
      .update(action)
      .then(() => {
        if (type === "Approve") {
          this.setState({
            ...this.state,
            vendor: null,
            popupOpened: false,
            popupData: {
              title: "",
              which: "",
            },
          });
        }
        this.$f7.preloader.hide();
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  declineApplication(vendorId) {
    this.$f7.$("#admin-decline-reasons").show();
  }

  initMap(geoLoc) {
    if (geoLoc.lat === "" || geoLoc.lng === "") {
      this.setState({
        ...this.state,
        geoLoc: null,
      });
    } else {
      this.setState({
        ...this.state,
        geoLoc,
      });
    }
  }
}

const mapStateToProps = ({ firebase: { auth }, DB: { data, ordered } }) => ({
  auth,
  data,
  ordered,
});

const enhance = compose(
  withFirestore,
  firestoreConnect([
    new Collections("merchants"),
    new Collections("delivery"),
    new Collections("partners"),
  ]),
  connect(mapStateToProps),
);

export default GoogleApiWrapper({
  apiKey: GOOGLE_MAP,
  language: "en",
})(enhance(AdminVendors));
